import { h } from "preact"
import { ColumnType } from "../types"
import Cell, { CellProps } from "./Cell"

export type RowType = {
   columns: ColumnType[]
   cells: Object
}

export default function Row({ cells, columns }: RowType) {
   const defFormatter = (cell: any, row: any) => cell

   return (
      <tr>
         {/* @ts-ignore TODO type*/}
         {columns.map((col) => (
            <Cell
               key={col.key}
               label={(cells as any)[col.key]}
               row={cells}
               formatter={col.formatter || defFormatter}
               className={col.tdClassName}
            />
         ))}
      </tr>
   )
}
